import getFontClass from '../../utils/getFontClass';

const extractPreheading = (preheadings) => {
  let text = '';
  preheadings.forEach((preheading) => {
    const style = preheading.pre_heading_style.split('-');
    text += `<span class="fontfamily--${style[0]} ${getFontClass(preheading.pre_heading_size)}" style="font-weight:${
      style[1]
    };">${preheading.pre_heading_text}</span>`;
  });
  return text;
};

const extractHeading = (headings) => {
  let text = '';
  headings.forEach((heading) => {
    const style = heading.heading_style.split('-');
    text += `<span class="fontfamily--${style[0]} ${getFontClass(heading.heading_size)}" style="font-weight:${
      style[1]
    };">${heading.heading_text}</span>`;
  });
  return text;
};

const extractTiles = (tiles) => {
  let html = '';
  tiles.forEach((tile) => {
    const tileData = tile.dataset;
    html += `
      <div class="Module-RelatedContent__Tile" data-slider-tile>
        <h6 class="Module-RelatedContent__Tile--Title">${tileData.tileTitle}</h6>
        <div class="Module-RelatedContent__Tile--Image">
          <img src="${tileData.tileImage}" alt="${tileData.tileImageAlt}" />
        </div>
        <div class="Module-RelatedContent__Tile--Button">
          <a class="Module__Button Button Button--primary" href="${tileData.tileUrl}">${tileData.tileTextView}</a>
        </div>
      </div>
    `;
  });
  return html;
};

export default (settings, module_name) => {
  const contentContainer = document.querySelector('[data-content-container]');
  const tiles = extractTiles(contentContainer.querySelectorAll('[data-related-content-tile]'));
  const html = `
    <div class="Module-${module_name}__Content">
      <h3 class="Module-${module_name}__Preheading">
        ${extractPreheading(settings.pre_heading)}
      </h3>
      <h2 class="Module-${module_name}__Heading">
        ${extractHeading(settings.heading)}
      </h2>
      <div class="Module-${module_name}__Articles" data-cms-related-content-slider>
        <div class="ScrollCarousel__viewport" data-cms-related-content-viewport>
          <div class="ScrollCarousel__track" data-cms-related-content-track>
            ${tiles}
          </div>
        </div>
      </div>
    </div>
  `;
  return html;
};
